import { useTranslation } from "react-i18next";

const WasteFlowHeader = ({ onSort, sortByField, orderSortByField }) => {
  const { t } = useTranslation();

  const handleSort = (field) => {
    if (!onSort) return;
    if (sortByField === field) {
      onSort(field, orderSortByField === "1" ? "-1" : "1");
    } else {
      onSort(field, "1");
    }
  };

  const getSortIcon = (field) => {
    if (sortByField === field) {
      return orderSortByField === "1" ? "fa-sort-up" : "fa-sort-down";
    }
    return "fa-sort";
  };

  const Sortable = ({ field, children }) => (
    <div
      className="table-standard-header-cell"
      style={{ cursor: "pointer" }}
      onClick={() => handleSort(field)}
    >
      {children}
      <span className="sort-icon">
        <i className={`fas ${getSortIcon(field)}`} aria-hidden />
      </span>
    </div>
  );

  return (
    <article className="table-standard-header">
      <Sortable field="label">{t("Waste Category")}</Sortable>
      <Sortable field="density">{t("Density")}</Sortable>
      <Sortable field="treatmentCostFull">{t("Treatment cost")}</Sortable>
      <div className="table-standard-header-cell">
        {t("settingsWaste.colProUnauthorized")}
      </div>
    </article>
  );
};

export default WasteFlowHeader;
